var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _c('b-overlay', {
    class: {
      'opacity-2': _vm.isRequestingSuggestion
    },
    attrs: {
      "show": _vm.isSaving
    }
  }, [_vm.rerouteMode && _vm.hasReroutableDispatchRequests ? _c('h5', {
    staticClass: "mb-2 text-dark"
  }, [_vm._v("Bestaande leveringen")]) : _vm._e(), _vm._l(_vm.currentDispatchRequests, function (dispatchRequest, index) {
    var _vm$quickRerouteLine$, _vm$quickRerouteLine, _vm$dispatchRequestHi, _vm$dispatchRequestHi2, _vm$dispatchRequestHi3, _vm$dispatchRequestHi4, _vm$dispatchRequestHi5, _dispatchRequest$casc, _dispatchRequest$resp, _dispatchRequest$resp2, _dispatchRequest$resp3, _dispatchRequest$resp4, _dispatchRequest$meta, _dispatchRequest$box_, _dispatchRequest$box_2, _dispatchRequest$trac, _dispatchRequest$stor, _dispatchRequest$stor2;
    return !_vm.rerouteMode || dispatchRequest.isReroutable ? _c('div', {
      key: dispatchRequest.id,
      staticClass: "dispatchRequest mb-4 mt-1 font-size-md p-4 card",
      class: {
        'opacity-2': _vm.isDragging,
        'drag-not-allowed': _vm.isDragging
      },
      attrs: {
        "data-drq-id": dispatchRequest.id,
        "no-body": ""
      }
    }, [_c('b-modal', {
      attrs: {
        "id": `quick-reroute-quantity-modal-${dispatchRequest.id}`,
        "title": _vm.quickRerouteLine ? (_vm$quickRerouteLine$ = (_vm$quickRerouteLine = _vm.quickRerouteLine) === null || _vm$quickRerouteLine === void 0 ? void 0 : _vm$quickRerouteLine.product_name) !== null && _vm$quickRerouteLine$ !== void 0 ? _vm$quickRerouteLine$ : _vm.getSalesOrderLine(_vm.quickRerouteLine.sales_order_line_id).product_name : '',
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none",
        "okTitle": _vm.$t('omt.gui.general.action.process'),
        "cancelTitle": _vm.$t('omt.gui.general.action.cancel')
      },
      on: {
        "ok": function ($event) {
          return _vm.quickRerouteDispatchRequestLine(dispatchRequest, _vm.quickRerouteLine, _vm.quickRerouteQuantity, _vm.quickRerouteToStatus, _vm.quickRerouteDispatchDate);
        }
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "10"
      }
    }, [_vm._v(" Welk aantal wil je "), _vm.quickRerouteToStatus === 'cancelled' ? _c('span', [_vm._v("annuleren")]) : _vm.quickRerouteToStatus === 'unable-to-ship' ? _c('span', [_vm._v("voorlopig manco melden")]) : _vm.quickRerouteToStatus === 'unable-to-ship-final' ? _c('span', [_vm._v("definitief manco melden")]) : _vm.quickRerouteToStatus === 'on-hold' ? _c('span', [_vm._v("blokkeren")]) : _vm.quickRerouteToStatus === 'to-be-requested' ? _c('span', [_vm._v("later uitleveren")]) : _c('span', [_vm._v("wijzigen")]), _vm._v(" ? ")]), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "size": "sm",
        "min": 1
      },
      model: {
        value: _vm.quickRerouteQuantity,
        callback: function ($$v) {
          _vm.quickRerouteQuantity = $$v;
        },
        expression: "quickRerouteQuantity"
      }
    })], 1)], 1), _vm.quickRerouteDispatchDate !== false ? _c('b-row', {
      staticClass: "mt-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "8"
      }
    }, [_vm._v("Wat wordt de nieuwe uitleverdatum?")]), _c('b-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('b-input', {
      attrs: {
        "type": "date",
        "size": "sm",
        "min": 1
      },
      model: {
        value: _vm.quickRerouteDispatchDate,
        callback: function ($$v) {
          _vm.quickRerouteDispatchDate = $$v;
        },
        expression: "quickRerouteDispatchDate"
      }
    })], 1)], 1) : _vm._e()], 1), _c('b-modal', {
      attrs: {
        "id": `ask-split-quantity-modal-${dispatchRequest.id}`,
        "title": "Splitsen",
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.splitLine(dispatchRequest, _vm.lineToSplit, _vm.productQuantityToSplit);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref) {
          var ok = _ref.ok;
          return [_c('form', {
            on: {
              "submit": function ($event) {
                $event.preventDefault();
                return ok();
              }
            }
          }, [_c('b-row', [_c('b-col', {
            attrs: {
              "cols": "10"
            }
          }, [_vm._v("Welk aantal je opsplitsen?")]), _c('b-col', {
            attrs: {
              "cols": "2"
            }
          }, [_c('b-input', {
            attrs: {
              "type": "number",
              "size": "sm",
              "min": 1,
              "autofocus": ""
            },
            model: {
              value: _vm.productQuantityToSplit,
              callback: function ($$v) {
                _vm.productQuantityToSplit = $$v;
              },
              expression: "productQuantityToSplit"
            }
          })], 1)], 1)], 1)];
        }
      }], null, true),
      model: {
        value: dispatchRequest.isSplitModalOpen,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "isSplitModalOpen", $$v);
        },
        expression: "dispatchRequest.isSplitModalOpen"
      }
    }), _c('b-modal', {
      attrs: {
        "id": `ask-delay-modal-${dispatchRequest.id}`,
        "title": "Uitleverdatum aanpassen",
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.processQuickReroute({
            originalDispatchRequest: dispatchRequest,
            toStatus: 'to-be-requested',
            newDispatchDate: _vm.quickRerouteDispatchDate
          });
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (_ref2) {
          var ok = _ref2.ok;
          return [_c('form', {
            on: {
              "submit": function ($event) {
                $event.preventDefault();
                return ok();
              }
            }
          }, [_c('b-row', [_c('b-col', {
            attrs: {
              "cols": "8"
            }
          }, [_vm._v("Wat wordt de nieuwe uitleverdatum?")]), _c('b-col', {
            attrs: {
              "cols": "4"
            }
          }, [_c('b-input', {
            attrs: {
              "type": "date",
              "size": "sm",
              "min": _vm.today,
              "required": "",
              "autofocus": ""
            },
            model: {
              value: _vm.quickRerouteDispatchDate,
              callback: function ($$v) {
                _vm.quickRerouteDispatchDate = $$v;
              },
              expression: "quickRerouteDispatchDate"
            }
          })], 1)], 1)], 1)];
        }
      }], null, true)
    }), _c('b-modal', {
      attrs: {
        "id": `ask-pause-modal-${dispatchRequest.id}`,
        "title": `Levering pauzeren`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.processPauseDispatchRequest(dispatchRequest);
        }
      }
    }, [_vm._v(" Weet je zeker dat je de levering wilt pauzeren? ")]), _c('b-modal', {
      attrs: {
        "id": `ask-resume-modal-${dispatchRequest.id}`,
        "title": `Levering hervatten`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.processResumeDispatchRequest(dispatchRequest);
        }
      }
    }, [_vm._v(" Weet je zeker dat je de levering wilt hervatten? ")]), _c('b-modal', {
      attrs: {
        "id": `ask-override-pickupcode-modal-${dispatchRequest.id}`,
        "title": `Markeer als afgehaald`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.processOverridePickupCode(dispatchRequest);
        }
      }
    }, [_vm._v(" Weet je zeker dat je de levering wilt markeren als afgehaald? ")]), _c('b-modal', {
      attrs: {
        "id": `responsible-location-modal-${dispatchRequest.id}`,
        "okTitle": _vm.$t('omt.gui.general.action.save'),
        "cancelTitle": _vm.$t('omt.gui.general.action.cancel'),
        "ok-disabled": !_vm.responsibleLocationChange.responsibleLocationId,
        "title": `${_vm.$t('omt.gui.orders.choose-responsible-location.title')}`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.handleProcessResponsibleLocation(dispatchRequest);
        }
      }
    }, [_c('ChooseResponsibleLocation', {
      attrs: {
        "sales-order": _vm.salesOrder
      },
      on: {
        "dataChange": function () {
          var _vm2;
          return (_vm2 = _vm).responsibleLocationPopupDataChange.apply(_vm2, arguments);
        }
      }
    })], 1), _c('b-modal', {
      attrs: {
        "id": `choose-dropshipper-modal-${dispatchRequest.id}`,
        "okTitle": _vm.$t('omt.gui.general.action.save'),
        "cancelTitle": _vm.$t('omt.gui.general.action.cancel'),
        "ok-disabled": !_vm.chooseDropshipper.dispatcherIdentifier,
        "title": "Dropshipper kiezen",
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.handleProcessChooseDropshipper(dispatchRequest);
        }
      }
    }, [_c('ChooseDropshipper', {
      attrs: {
        "dispatchRequest": dispatchRequest
      },
      on: {
        "dataChange": function () {
          var _vm3;
          return (_vm3 = _vm).chooseDropshipperPopupDataChange.apply(_vm3, arguments);
        }
      }
    })], 1), _c('b-modal', {
      attrs: {
        "id": `change-location-modal-${dispatchRequest.id}`,
        "title": "Locatie wijzigen",
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none",
        "ok-disabled": !_vm.isQuickRerouteLocationValid
      },
      on: {
        "ok": function ($event) {
          return _vm.processQuickReroute({
            originalDispatchRequest: dispatchRequest,
            newLocation: _vm.newDispatchRequestLocation,
            lines: dispatchRequest.dispatch_request_lines
          });
        }
      }
    }, [_c('b-row', {
      staticClass: "new-dr-location mb-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm._v(" Wat wordt de nieuwe locatie? ")]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm.loadingQuickRerouteLocations ? [_c('span', {
      staticClass: "icon mr-2"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "spinner",
        "spin": ""
      }
    })], 1), _c('span', {
      staticClass: "label"
    }, [_vm._v(" Lijst met locaties ophalen… ")])] : [_vm.quickRerouteLocationLocations.length == 0 ? _c('span', [_vm._v(" Er zijn geen locaties beschikbaar. ")]) : _c('b-form-select', {
      attrs: {
        "size": "sm"
      },
      on: {
        "change": function ($event) {
          return _vm.getDispatchTypesForDispatcher(_vm.newDispatchRequestLocation.dispatcher_identifier);
        }
      },
      model: {
        value: _vm.newDispatchRequestLocation.dispatcher_identifier,
        callback: function ($$v) {
          _vm.$set(_vm.newDispatchRequestLocation, "dispatcher_identifier", $$v);
        },
        expression: "newDispatchRequestLocation.dispatcher_identifier"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Kies een locatie… ")]), _vm._l(_vm.quickRerouteLocationLocations, function (location) {
      return _c('b-form-select-option', {
        key: location.id,
        attrs: {
          "value": location.identifier
        }
      }, [_vm._v(" " + _vm._s(location.display_name) + " (" + _vm._s(location.identifier) + ") ")]);
    })], 2)]], 2)], 1), _vm.newDispatchRequestLocation.dispatcher_identifier !== null ? _c('b-row', {
      staticClass: "new-dr-location-dispatch-type mb-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm._v(" Wat wordt de vervoersmethode? ")]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm.loadingQuickRerouteDispatchTypes ? [_c('span', {
      staticClass: "icon mr-2"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "spinner",
        "spin": ""
      }
    })], 1), _c('span', {
      staticClass: "label"
    }, [_vm._v(" Lijst met vervoersmethoden ophalen… ")])] : [_vm.quickRerouteLocationDispatchTypes.length == 0 ? _c('span', {
      staticClass: "no-dispatch-types-available"
    }, [_vm._v(" Geen vervoersmethoden beschikbaar voor deze locatie. ")]) : _c('b-form-select', {
      attrs: {
        "size": "sm"
      },
      model: {
        value: _vm.newDispatchRequestLocation.dispatch_type,
        callback: function ($$v) {
          _vm.$set(_vm.newDispatchRequestLocation, "dispatch_type", $$v);
        },
        expression: "newDispatchRequestLocation.dispatch_type"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Kies een vervoersmethode… ")]), _vm._l(_vm.quickRerouteLocationDispatchTypes, function (dispatch_type) {
      return _c('b-form-select-option', {
        key: dispatch_type.id,
        attrs: {
          "value": dispatch_type
        }
      }, [_vm._v(" " + _vm._s(dispatch_type.display_name) + " ")]);
    })], 2)]], 2)], 1) : _vm._e(), _vm.newDispatchRequestLocation.dispatch_type !== null ? _c('b-row', {
      staticClass: "new-dr-location-carrier mb-2"
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm._v(" Wie wordt de vervoerder? ")]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [!_vm.dispatchTypeHasActiveCarriers(_vm.newDispatchRequestLocation.dispatch_type) ? _c('span', {
      staticClass: "no-dispatch-types-available"
    }, [_vm.newDispatchRequestLocation.dispatch_type.identifier === 'vendor_dropship' ? [_vm._v(" De leverancier zal de bestelling direct naar de klant sturen. ")] : [_vm._v(" Geen vervoerders beschikbaar voor deze locatie. ")]], 2) : _c('b-row', [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('b-form-select', {
      attrs: {
        "size": "sm"
      },
      model: {
        value: _vm.newDispatchRequestLocation.carrier,
        callback: function ($$v) {
          _vm.$set(_vm.newDispatchRequestLocation, "carrier", $$v);
        },
        expression: "newDispatchRequestLocation.carrier"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Kies een vervoerder… ")]), _vm._l(_vm.getActiveCarriersForDispatchType(_vm.newDispatchRequestLocation.dispatch_type), function (carrier) {
      return _c('b-form-select-option', {
        key: carrier.id,
        attrs: {
          "value": carrier
        }
      }, [_vm._v(" " + _vm._s(carrier.display_name) + " ")]);
    })], 2)], 1)], 1)], 1)], 1) : _vm._e(), _vm.newDispatchRequestLocation.carrier !== null ? _c('b-row', {
      staticClass: "new-dr-location-carrier-method"
    }, [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_vm._v(" Wat wordt de vervoersmethode? ")]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [!_vm.carrierHasActiveCarrierMethods(_vm.newDispatchRequestLocation.carrier) ? _c('span', [_vm._v(" Geen vervoermethoden beschikbaar voor deze vervoerder. ")]) : _c('b-row', [_c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('b-form-select', {
      attrs: {
        "size": "sm"
      },
      model: {
        value: _vm.newDispatchRequestLocation.carrier_method,
        callback: function ($$v) {
          _vm.$set(_vm.newDispatchRequestLocation, "carrier_method", $$v);
        },
        expression: "newDispatchRequestLocation.carrier_method"
      }
    }, [_c('b-form-select-option', {
      attrs: {
        "value": null
      }
    }, [_vm._v(" Kies een vervoersmethode… ")]), _vm._l(_vm.getActiveCarrierMethodsForCarrier(_vm.newDispatchRequestLocation.carrier), function (carrier_method) {
      return _c('b-form-select-option', {
        key: carrier_method.id,
        attrs: {
          "value": carrier_method
        }
      }, [_vm._v(" " + _vm._s(carrier_method.display_name) + " ")]);
    })], 2)], 1)], 1)], 1)], 1) : _vm._e()], 1), _c('b-modal', {
      key: `suggestion-for-dispatch-request-modal-${dispatchRequest.id}`,
      attrs: {
        "id": `suggestion-for-dispatch-request-modal-${dispatchRequest.id}`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none",
        "title": "Reroute suggestie vragen"
      },
      on: {
        "ok": function ($event) {
          return _vm.getSuggestionForDispatchRequest(dispatchRequest, true);
        }
      },
      model: {
        value: dispatchRequest.isSuggestionModalOpen,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "isSuggestionModalOpen", $$v);
        },
        expression: "dispatchRequest.isSuggestionModalOpen"
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "10"
      }
    }, [_vm._v(" Wat is het maximaal aantal leveringen? ")]), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "size": "sm",
        "min": 1
      },
      model: {
        value: _vm.rerouteMaxDispatchRequests,
        callback: function ($$v) {
          _vm.rerouteMaxDispatchRequests = $$v;
        },
        expression: "rerouteMaxDispatchRequests"
      }
    })], 1)], 1), _c('b-row', {
      staticClass: "mt-4"
    }, [_c('b-col', {
      attrs: {
        "cols": "10 pt-1"
      }
    }, [_vm._v(" Sluit eerder gebruikte locaties voor " + _vm._s(_vm.$store.state.config.settings.excludePreviousLocationsForHourCount) + " uur uit: ")]), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-checkbox', {
      attrs: {
        "type": "number",
        "size": "lg",
        "switch": ""
      },
      model: {
        value: _vm.rerouteSuggestionExcludePreviousLocations,
        callback: function ($$v) {
          _vm.rerouteSuggestionExcludePreviousLocations = $$v;
        },
        expression: "rerouteSuggestionExcludePreviousLocations"
      }
    })], 1)], 1)], 1), _c('b-modal', {
      attrs: {
        "id": `drq-line-history-modal-${dispatchRequest.id}`,
        "title": `Leveringsstatus-geschiedenis van artikel ${(_vm$dispatchRequestHi = _vm.dispatchRequestHistoryLine) === null || _vm$dispatchRequestHi === void 0 ? void 0 : _vm$dispatchRequestHi.product_identifier} - ${(_vm$dispatchRequestHi2 = (_vm$dispatchRequestHi3 = _vm.dispatchRequestHistoryLine) === null || _vm$dispatchRequestHi3 === void 0 ? void 0 : _vm$dispatchRequestHi3.product_name) !== null && _vm$dispatchRequestHi2 !== void 0 ? _vm$dispatchRequestHi2 : _vm.getSalesOrderLine((_vm$dispatchRequestHi4 = _vm.dispatchRequestHistoryLine) === null || _vm$dispatchRequestHi4 === void 0 ? void 0 : _vm$dispatchRequestHi4.sales_order_line_id).product_name}`,
        "size": "xl",
        "centered": "",
        "dialog-class": "shadow-none",
        "hide-footer": ""
      }
    }, [_vm.dispatchRequestHistoryLine ? _c('dispatch-request-history', {
      key: (_vm$dispatchRequestHi5 = _vm.dispatchRequestHistoryLine) === null || _vm$dispatchRequestHi5 === void 0 ? void 0 : _vm$dispatchRequestHi5.id,
      attrs: {
        "dispatch-request-line": _vm.dispatchRequestHistoryLine,
        "sales-order": _vm.salesOrder
      }
    }) : _vm._e()], 1), _c('b-modal', {
      attrs: {
        "id": `switch-carrier-method-modal-${dispatchRequest.id}`,
        "title": "Wijzig vervoersmethode",
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none"
      },
      on: {
        "ok": function ($event) {
          return _vm.handleSwitchCarrier(dispatchRequest);
        }
      }
    }, [_c('switch-carrier-method', {
      attrs: {
        "dispatch-request": dispatchRequest
      },
      on: {
        "dataChange": function () {
          var _vm4;
          return (_vm4 = _vm).switchCarrierDataChange.apply(_vm4, arguments);
        }
      }
    })], 1), _c('div', {
      attrs: {
        "data-drq-id": dispatchRequest.id
      }
    }, [_c('BRow', [_c('BCol', {
      attrs: {
        "cols": "12 p-0"
      }
    }, [_c('b-alert', {
      staticClass: "mb-2",
      attrs: {
        "show": dispatchRequest.paused_at,
        "variant": "warning"
      }
    }, [_c('strong', [_c('font-awesome-icon', {
      staticClass: "text-danger font-size-xlg align-middle mr-2",
      attrs: {
        "icon": "pause-circle"
      }
    })], 1), _vm._v(" Deze levering is gepauzeerd! Er zullen geen updates plaatsvinden totdat deze weer wordt hervat. ")]), _c('b-alert', {
      staticClass: "mb-2",
      attrs: {
        "variant": "warning",
        "show": _vm.hasAssignMessages(dispatchRequest)
      }
    }, [_c('font-awesome-icon', {
      staticClass: "text-info font-size-xlg align-middle mr-2",
      attrs: {
        "icon": "bullhorn"
      }
    }), _vm.hasAssignMessages(dispatchRequest) ? _c('span', [dispatchRequest.status === 'unable-to-ship' ? _c('strong', [_vm._v("Afwijsreden:")]) : _c('strong', [_vm._v("HARR Redenen:")]), _c('ul', {
      staticClass: "mb-0",
      class: {
        'mb-2': dispatchRequest.is_dispatch_assign_retryable
      }
    }, [_vm._l(_vm.relevantAssignMessages(dispatchRequest), function (assignComponentResult) {
      return _c('li', [_vm._v(" " + _vm._s(_vm.getAssignComponentResultMessage(assignComponentResult)) + " ")]);
    }), _vm.getUnableToShipReasonForHarr(dispatchRequest) ? _c('li', [_vm._v(" " + _vm._s(_vm.getUnableToShipReasonForHarr(dispatchRequest)) + " ")]) : _vm._e()], 2)]) : _vm._e(), dispatchRequest.is_dispatch_assign_retryable ? _c('small', [_c('i', [_vm._v("Deze levering wordt opnieuw geprobeerd om automatisch toe te wijzen na: " + _vm._s(_vm._f("datetimeshort")(dispatchRequest.reassign_at)) + ".")])]) : _vm._e()], 1)], 1)], 1), _c('BRow', {
      class: _vm.showInformationHeadings ? 'mb-4' : 'mb-0'
    }, [_c('BCol', {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "3"
      }
    }, [_c('BCardTitle', {
      class: {
        'text-danger': dispatchRequest.status === 'cancelled'
      }
    }, [_c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip",
        value: dispatchRequest.status_reason,
        expression: "dispatchRequest.status_reason"
      }],
      staticClass: "text-uppercase"
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('DispatchRequestIcon', {
      attrs: {
        "status": dispatchRequest.status
      }
    }), _vm._v("  ")], 1), dispatchRequest.is_replaced && !_vm.showReplacedAsNormal ? _c('span', {
      staticClass: "icon"
    }, [_c('DispatchRequestIcon', {
      attrs: {
        "status": "rerouted"
      }
    }), _vm._v("  ")], 1) : _vm._e(), _c('span', {
      staticClass: "drq-status-label",
      class: {
        'text-strikethrough': _vm.getStrikeThrough(dispatchRequest)
      },
      attrs: {
        "data-original-status": dispatchRequest.status
      }
    }, [_vm._v(" " + _vm._s(_vm.dispatchRequestStatus(dispatchRequest.status, dispatchRequest.dispatch_type.identifier)) + " "), dispatchRequest.status_reason ? _c('small', [_c('font-awesome-icon', {
      staticClass: "text-secondary d-inline-block ml-1",
      attrs: {
        "icon": "circle-info"
      }
    })], 1) : _vm._e()])])])], 1), _c('BCol', {
      attrs: {
        "cols": "9"
      }
    }, [_vm.isResponsibleLocationChanged(dispatchRequest) ? _c('span', {
      staticClass: "d-inline-block ml-4 text-danger text-uppercase font-weight-bold float-right"
    }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.is-responsible-location-changed-message')) + " ")]) : !_vm.hideActions && !dispatchRequest.is_replaced && !_vm.isRerouted(dispatchRequest) ? _c('OmniButtonCollection', {
      staticClass: "justify-content-end"
    }, [_vm.canQuickRerouteToLocation(dispatchRequest) ? _c('OmniButton', {
      attrs: {
        "icon": "fas fa-map-marked-alt"
      },
      on: {
        "click": function ($event) {
          return _vm.changeDispatchRequestLocation(dispatchRequest);
        }
      }
    }, [_vm._v(" Wijs toe aan winkel ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isPausable ? _c('OmniButton', {
      attrs: {
        "icon": "pause-circle"
      },
      on: {
        "click": function ($event) {
          return _vm.pauseDispatchRequest(dispatchRequest);
        }
      }
    }, [_vm._v(" Pauzeer deze levering ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isUnpausable ? _c('OmniButton', {
      attrs: {
        "icon": "play-circle"
      },
      on: {
        "click": function ($event) {
          return _vm.resumeDispatchRequest(dispatchRequest);
        }
      }
    }, [_vm._v(" Resumeer deze levering ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isResponsibleLocationChangable ? _c('OmniButton', {
      attrs: {
        "icon": "user-tie"
      },
      on: {
        "click": function ($event) {
          return _vm.openChooseResponsibleLocationModal(dispatchRequest);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.search.filters.label.responsible-store-identifier')) + " omzetten ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isChooseDropshipperVisible ? _c('OmniButton', {
      attrs: {
        "icon": "parachute-box"
      },
      on: {
        "click": function ($event) {
          return _vm.openChooseDropshipperModal(dispatchRequest);
        }
      }
    }, [_vm._v(" Producten dropshippen ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isDelayable ? _c('OmniButton', {
      attrs: {
        "icon": "calendar"
      },
      on: {
        "click": function ($event) {
          return _vm.delayDispatchRequest(dispatchRequest, 'to-be-requested');
        }
      }
    }, [_vm._v(" Leverdatum aanpassen ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isSwitchCarrierAvailable ? _c('OmniButton', {
      attrs: {
        "icon": "truck"
      },
      on: {
        "click": function ($event) {
          return _vm.openSwitchCarrierModal(dispatchRequest);
        }
      }
    }, [_vm._v(" Vervoersmethode wijzigen ")]) : _vm._e(), _vm.showDispatchRequestDeliveryFields(dispatchRequest) ? _c('download-packing-slip-button', {
      attrs: {
        "dispatch-request": dispatchRequest,
        "always-show": dispatchRequest.dispatcher_type === 'dc' && _vm.hasPermission('orders.dispatchrequests.downloadpackingslip'),
        "size": "md"
      }
    }, [_vm._v(" Download pakbon en label ")]) : _vm._e(), _vm.isExtraLabelButtonVisible(dispatchRequest) ? _c('download-packing-slip-button', {
      attrs: {
        "dispatch-request": dispatchRequest,
        "ignore-cache": true,
        "ask-label-count": true,
        "always-show": true,
        "size": "md"
      }
    }, [_vm._v(" Extra labels aanvragen ")]) : _vm._e(), _vm.showDispatchRequestDeliveryFields(dispatchRequest) ? _c('print-labels-button', {
      attrs: {
        "dispatch-request": dispatchRequest,
        "size": "md"
      }
    }) : _vm._e(), _vm.hasPermission('orders.dispatchrequests.showcascades') && (_dispatchRequest$casc = dispatchRequest.cascades_into_dispatch_requests) !== null && _dispatchRequest$casc !== void 0 && _dispatchRequest$casc.length ? _c('OmniButton', {
      attrs: {
        "icon": "link"
      },
      on: {
        "click": function ($event) {
          return _vm.openCascadedDispatchRequestsModal(dispatchRequest);
        }
      }
    }, [_vm._v(" Toon gelinkte leveringen ")]) : _vm._e(), _vm.isOrderPickByStoreScannable(dispatchRequest) ? _c('OmniButton', {
      attrs: {
        "variant": "outline-primary",
        "size": "md",
        "icon": "barcode",
        "to": {
          name: 'OrderPickByStoreScan',
          params: {
            salesOrderIdentifier: _vm.salesOrder.identifier,
            dispatchRequestId: dispatchRequest.id
          }
        }
      }
    }, [_vm._v(" Pick deze levering ")]) : _vm._e(), _vm.hasPermission('orders.dispatchrequests.createreturn') ? _c('OmniButton', {
      attrs: {
        "variant": "link",
        "icon": "reply"
      },
      on: {
        "click": function ($event) {
          return _vm.openReturnDrqItemsModal(dispatchRequest);
        }
      }
    }, [_vm._v(" Artikelen retourneren ")]) : _vm._e(), !dispatchRequest.dispatch_request_batch_id && _vm.hasPermission('orders.batch.create') && dispatchRequest.status === 'to-be-requested' ? _c('OmniButton', {
      attrs: {
        "disabled": _vm.isCreatingBatch,
        "is-processing": _vm.isCreatingBatch,
        "icon": "box-open"
      },
      on: {
        "click": function ($event) {
          return _vm.handleCreateBatch(dispatchRequest);
        }
      }
    }, [_vm._v(" Batch aanmaken ")]) : _vm._e(), dispatchRequest.dispatch_request_batch_id && _vm.hasPermission('orders.batch.process.sort') ? _c('OmniButton', {
      attrs: {
        "to": {
          name: 'ProcessStartWithBatch',
          params: {
            batchModelType: 'shipment-batch',
            processType: 'sort',
            locationTypeIdentifier: dispatchRequest.dispatcher_type,
            locationIdentifier: dispatchRequest.dispatcher_identifier,
            batchModelIdentifier: dispatchRequest.dispatch_request_batch.identifier
          }
        },
        "icon": "layer-group"
      }
    }, [_vm._v(" Batch sorteren ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isHoldable ? _c('OmniButton', {
      attrs: {
        "variant": "danger",
        "icon": "truck"
      },
      on: {
        "click": function ($event) {
          return _vm.quickRerouteDispatchRequest(dispatchRequest, 'on-hold');
        }
      }
    }, [_vm._v(" Levering blokkeren ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isCancelable ? _c('OmniButton', {
      attrs: {
        "variant": "danger",
        "icon": "ban"
      },
      on: {
        "click": function ($event) {
          return _vm.quickRerouteDispatchRequest(dispatchRequest, 'cancelled');
        }
      }
    }, [_vm._v(" Levering annuleren ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isPickupCodeOverridable ? _c('OmniButton', {
      attrs: {
        "icon": "user-check"
      },
      on: {
        "click": function ($event) {
          return _vm.overridePickupCode(dispatchRequest);
        }
      }
    }, [_vm._v(" Markeer als afgehaald ")]) : _vm._e(), !_vm.rerouteMode && dispatchRequest.isShippable ? _c('OmniButton', {
      attrs: {
        "variant": "success",
        "icon": "truck"
      },
      on: {
        "click": function ($event) {
          return _vm.quickRerouteDispatchRequest(dispatchRequest, 'shipped');
        }
      }
    }, [_vm._v(" Markeer als verzonden ")]) : _vm._e()], 1) : _vm._e(), _vm.$scopedSlots.extraActions ? _c('OmniButtonCollection', {
      staticClass: "justify-content-end"
    }, [_vm._t("extraActions", null, {
      "dispatchRequest": dispatchRequest
    })], 2) : _vm._e(), _vm.rerouteMode ? _c('OmniButtonCollection', {
      staticClass: "justify-content-end"
    }, [_vm.hasPermission('orders.dispatchrequests.suggestionbased.reroute') && _vm.rerouteMode && dispatchRequest.isReroutable ? _c('OmniButton', {
      on: {
        "click": function ($event) {
          return _vm.toggleSuggestionForDispatchRequestModal(dispatchRequest);
        }
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function () {
          return [!_vm.isRequestingSuggestion ? _c('FontAwesomeIcon', {
            attrs: {
              "icon": "user-graduate"
            }
          }) : _vm._e(), _vm.isRequestingSuggestion ? _c('FontAwesomeIcon', {
            attrs: {
              "icon": "spinner",
              "spin": _vm.isRequestingSuggestion
            }
          }) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" Een reroute suggestie vragen ")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _c('BCol', {
      attrs: {
        "cols": "12"
      }
    }, [_c('BRow', {
      staticClass: "d-flex flex-wrap",
      staticStyle: {
        "font-size": ".85rem",
        "gap": "1.5rem 4rem"
      }
    }, [dispatchRequest.responsible_location && _vm.showDrqInformationBlock('responsible_location') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.responsible-location')) + " ")])]) : _vm._e(), _c('span', [!_vm.showLocationLink((_dispatchRequest$resp = dispatchRequest.responsible_location) === null || _dispatchRequest$resp === void 0 ? void 0 : _dispatchRequest$resp.location_type.identifier, (_dispatchRequest$resp2 = dispatchRequest.responsible_location) === null || _dispatchRequest$resp2 === void 0 ? void 0 : _dispatchRequest$resp2.identifier) ? _c('span', [_vm._v(_vm._s(dispatchRequest.responsible_location.display_name))]) : _c('b-link', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "to": {
          name: 'EditLocationServices',
          params: {
            locationTypeIdentifier: (_dispatchRequest$resp3 = dispatchRequest.responsible_location) === null || _dispatchRequest$resp3 === void 0 ? void 0 : _dispatchRequest$resp3.location_type.identifier,
            locationIdentifier: (_dispatchRequest$resp4 = dispatchRequest.responsible_location) === null || _dispatchRequest$resp4 === void 0 ? void 0 : _dispatchRequest$resp4.identifier
          }
        },
        "title": "Bekijk locatie"
      }
    }, [_vm._v(_vm._s(dispatchRequest.responsible_location.display_name))])], 1)])]) : _vm._e(), _vm.showDrqInformationBlock('dispatcher_identifier') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.location')) + " ")])]) : _vm._e(), _c('span', [!_vm.showLocationLink(dispatchRequest.dispatcher_type, dispatchRequest.dispatcher_identifier) ? _c('span', [_vm._v(_vm._s(_vm.getDispatcherName(dispatchRequest)))]) : _c('b-link', {
      staticStyle: {
        "color": "inherit"
      },
      attrs: {
        "to": {
          name: 'EditLocationServices',
          params: {
            locationTypeIdentifier: dispatchRequest.dispatcher_type,
            locationIdentifier: dispatchRequest.dispatcher_identifier
          }
        },
        "title": "Bekijk locatie"
      }
    }, [_vm._v(_vm._s(_vm.getDispatcherName(dispatchRequest)))])], 1)])]) : _vm._e(), _vm.showDrqInformationBlock('location_type_identifier') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.label.location-type')) + " ")])]) : _vm._e(), _c('span', [_vm._v(" " + _vm._s(_vm.getDispatcherType(dispatchRequest)) + " ")])])]) : _vm._e(), _vm.showDispatchFields(dispatchRequest) && _vm.showDrqInformationBlock('dispatch_type') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" Type levering ")])]) : _vm._e(), _c('span', [_vm._v(" " + _vm._s(dispatchRequest.dispatch_type.display_name) + " " + _vm._s((_dispatchRequest$meta = dispatchRequest.metadata) !== null && _dispatchRequest$meta !== void 0 && _dispatchRequest$meta.auto_purchase ? '(Automatisch)' : '') + " ")])])]) : _vm._e(), _vm.showBoxSuggestion(dispatchRequest) && _vm.showDrqInformationBlock('suggested_box') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" Doosadvies ")])]) : _vm._e(), dispatchRequest.box_suggestion ? _c('span', {
      attrs: {
        "title": !_vm.showInformationHeadings ? 'Doosadvies' : false
      }
    }, [_vm._v(" " + _vm._s((_dispatchRequest$box_ = dispatchRequest.box_suggestion) === null || _dispatchRequest$box_ === void 0 ? void 0 : (_dispatchRequest$box_2 = _dispatchRequest$box_.suggested_box) === null || _dispatchRequest$box_2 === void 0 ? void 0 : _dispatchRequest$box_2.identifier) + " ")]) : _vm._e()])]) : _vm._e(), _vm.showDispatchFields(dispatchRequest) && _vm.showDispatchRequestDeliveryFields(dispatchRequest) && _vm.showDrqInformationBlock('carrier_identifier') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" Bezorging door ")])]) : _vm._e(), _c('span', {
      staticClass: "d-flex align-items-center",
      staticStyle: {
        "gap": ".25rem"
      }
    }, [dispatchRequest.carrier ? _c('carrier-icon', {
      staticClass: "carrier-icon d-inline-block align-middle mr-1",
      attrs: {
        "carrier": dispatchRequest.carrier.identifier
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(dispatchRequest.carrier_method ? dispatchRequest.carrier_method.display_name : 'Vervoersmethode onbekend') + " ")], 1)])]) : _vm._e(), _vm.showDispatchRequestDeliveryFields(dispatchRequest) && _vm.hasPermission('orders.dispatchrequests.showdatefield.dispatchdate') && _vm.showDrqInformationBlock('dispatch_date') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" Uitleverdatum ")])]) : _vm._e(), _c('span', [dispatchRequest.dispatch_date ? _c('span', {
      attrs: {
        "title": !_vm.showInformationHeadings ? 'Uitleverdatum' : false
      }
    }, [_vm._v(_vm._s(_vm._f("date")(dispatchRequest.dispatch_date)))]) : _c('span', [_vm._v("onbekend")])])])]) : _vm._e(), _vm.hasPermission('orders.dispatchrequests.showdatefield.updatedat') && _vm.showDrqInformationBlock('updated_at') ? _c('span', [_c('div', {
      staticClass: "d-flex flex-column"
    }, [_vm.showInformationHeadings ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(" Laatste update ")])]) : _vm._e(), _c('span', {
      attrs: {
        "title": !_vm.showInformationHeadings ? 'Laatste update' : false
      }
    }, [_vm._v(" " + _vm._s(_vm._f("datetime")(dispatchRequest.updated_at)) + " ")])])]) : _vm._e()])], 1)], 1), _c('b-card-body', {
      staticClass: "pl-0",
      attrs: {
        "body-bg-variant": "default"
      }
    }, [_c('b-table-simple', {
      staticClass: "mb-0",
      attrs: {
        "stacked": "sm",
        "small": "",
        "borderless": ""
      }
    }, [_c('colgroup', [_vm.rerouteMode && dispatchRequest.isReroutable ? _c('col', {
      staticStyle: {
        "width": "2rem"
      }
    }) : _vm._e(), _c('col', {
      staticStyle: {
        "width": "7rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "10rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "auto"
      }
    }), !_vm.rerouteMode ? _c('col', {
      staticStyle: {
        "width": "12rem"
      }
    }) : _vm._e(), !_vm.rerouteMode ? _c('col', {
      staticStyle: {
        "width": "8rem"
      }
    }) : _vm._e(), _vm.showFinancialAmounts ? _c('col', {
      staticStyle: {
        "width": "7rem"
      }
    }) : _vm._e(), _c('col', {
      staticStyle: {
        "width": "14rem"
      }
    })]), _c('b-thead', [_c('b-tr', [_vm.rerouteMode && dispatchRequest.isReroutable ? _c('b-th') : _vm._e(), _c('b-th', [_vm._v("Aantal")]), _c('b-th', [_vm._v("Artikel nr")]), _c('b-th', [_vm._v("Naam")]), !_vm.rerouteMode && _vm.showFinancialAmounts ? _c('b-th', [_vm._v("Prijs totaal (ex. korting)")]) : _vm._e(), !_vm.rerouteMode && _vm.showFinancialAmounts ? _c('b-th', [_vm._v("Korting")]) : _vm._e(), _vm.showFinancialAmounts ? _c('b-th', [_vm._v("Prijs totaal")]) : _vm._e(), _c('b-th', [_vm._v("Extra informatie")])], 1)], 1), _vm.rerouteMode && dispatchRequest.isReroutable ? _c('draggable', {
      attrs: {
        "tag": "tbody",
        "group": "productsInDispatchRequest",
        "forceFallback": true /* Required for cursor change to work */,
        "ghost-class": "ghost-product",
        "data-dispatch-request-id": dispatchRequest.id,
        "data-is-existing-dispatch-request": "1"
      },
      on: {
        "end": _vm.productMoved,
        "start": function ($event) {
          _vm.isDragging = true;
        },
        "unchoose": function ($event) {
          _vm.isDragging = false;
        }
      },
      model: {
        value: dispatchRequest.dispatch_request_lines,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatch_request_lines", $$v);
        },
        expression: "dispatchRequest.dispatch_request_lines"
      }
    }, _vm._l(dispatchRequest.dispatch_request_lines, function (line, index) {
      var _line$product_name;
      return _c('b-tr', {
        key: `${line.id}_${index}`,
        staticClass: "draggable",
        class: {
          'drag-not-allowed': _vm.isDragging
        }
      }, [_vm.rerouteMode && dispatchRequest.isReroutable ? _c('b-td', {
        staticClass: "text-secondary draggable"
      }, [_c('font-awesome-icon', {
        staticClass: "text-info",
        attrs: {
          "icon": "grip-vertical"
        }
      })], 1) : _vm._e(), _c('b-td', {
        attrs: {
          "stacked-heading": "Aantal"
        }
      }, [_vm._v(" " + _vm._s(line.quantity) + " "), line.quantity > 1 ? _c('b-button', {
        staticClass: "text-primary p-0 btn-split-drq",
        attrs: {
          "variant": "link",
          "size": "sm",
          "title": "Splitsen"
        },
        on: {
          "click": function ($event) {
            return _vm.startSplitLine(dispatchRequest, line);
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "share-alt"
        }
      })], 1) : _vm._e()], 1), _c('b-td', {
        attrs: {
          "stacked-heading": "Artikel nr"
        }
      }, [_c('product-number', {
        attrs: {
          "number": line.product_identifier,
          "dispatch-request-line": line,
          "sales-order-line": _vm.getSalesOrderLine(line.sales_order_line_id)
        }
      })], 1), _c('b-td', {
        attrs: {
          "stacked-heading": "Naam"
        }
      }, [_vm._v(_vm._s((_line$product_name = line.product_name) !== null && _line$product_name !== void 0 ? _line$product_name : _vm.getSalesOrderLine(line.sales_order_line_id).product_name))]), _vm.showFinancialAmounts ? _c('b-td', {
        attrs: {
          "stacked-heading": "Prijs totaal"
        }
      }, [_vm._v(" " + _vm._s(_vm._f("price")(_vm.getTotalPriceToShow(line, true))) + " "), _vm.hasOriginalExtraOrderLineUnitPrice(line) ? _c('small', {
        staticClass: "mr-2"
      }, [_c('font-awesome-icon', {
        staticClass: "ml-2 text-info align-text-top",
        attrs: {
          "icon": "circle-info",
          "title": "Nalevering, de getoonde prijs is die van de originele regel"
        }
      })], 1) : _vm._e()]) : _vm._e(), _c('b-td', {
        attrs: {
          "stacked-heading": "Extra info"
        }
      }, [_vm.shouldShowProductInsufficientStock(dispatchRequest, line.product_identifier) ? _c('small', {
        staticClass: "text-danger"
      }, [_c('font-awesome-icon', {
        staticClass: "text-warning",
        attrs: {
          "icon": "triangle-exclamation"
        }
      }), _vm._v(" Onvoldoende voorraad"), _c('br')], 1) : _vm._e(), dispatchRequest.storage_location_id && dispatchRequest.status === 'requested' ? _c('span', [_c('i', [_vm._v("Gescand: " + _vm._s(line.final_scanned_quantity))])]) : _vm._e()])], 1);
    }), 1) : _c('b-tbody', _vm._l(dispatchRequest.dispatch_request_lines, function (line) {
      var _line$product_name2, _line$presales_active, _vm$getSalesOrderLine, _vm$getSalesOrderLine2, _vm$getSalesOrderLine3, _vm$getSalesOrderLine4, _vm$getSalesOrderLine5, _vm$getSalesOrderLine6, _vm$getReturnReason$d, _vm$getProductState$d, _line$goods_receipt_l, _line$goods_receipt_l2, _line$goods_receipt_l3;
      return _c('b-tr', {
        key: line.id,
        attrs: {
          "data-line-id": line.id
        }
      }, [_c('b-td', {
        attrs: {
          "stacked-heading": "Aantal"
        }
      }, [_vm._v(" " + _vm._s(line.quantity) + " "), !_vm.hideActions ? _c('span', [dispatchRequest.isDelayable ? _c('b-button', {
        staticClass: "text-danger ml-1 m-0 p-0",
        attrs: {
          "size": "sm",
          "variant": "link",
          "title": "Dit product later uitleveren"
        },
        on: {
          "click": function ($event) {
            return _vm.startQuickRerouteDispatchRequestLine(dispatchRequest, line, 'to-be-requested', true);
          }
        }
      }, [_c('small', {
        staticClass: "align-text-bottom text-dark"
      }, [_c('font-awesome-icon', {
        staticClass: "align-text-top",
        attrs: {
          "icon": "far fa-calendar"
        }
      })], 1)]) : _vm._e(), dispatchRequest.isCancelable ? _c('b-button', {
        staticClass: "text-danger ml-1 m-0 p-0",
        attrs: {
          "size": "sm",
          "variant": "link",
          "title": "Dit product annuleren"
        },
        on: {
          "click": function ($event) {
            return _vm.startQuickRerouteDispatchRequestLine(dispatchRequest, line, 'cancelled');
          }
        }
      }, [_c('small', {
        staticClass: "align-text-bottom"
      }, [_c('font-awesome-icon', {
        staticClass: "align-text-top",
        attrs: {
          "icon": "ban"
        }
      })], 1)]) : _vm._e(), dispatchRequest.isUnableToShipable ? _c('b-button', {
        staticClass: "text-warning ml-1 m-0 p-0",
        attrs: {
          "size": "sm",
          "variant": "link",
          "title": "Dit product op manco zetten"
        },
        on: {
          "click": function ($event) {
            return _vm.startQuickRerouteDispatchRequestLine(dispatchRequest, line, 'unable-to-ship');
          }
        }
      }, [_c('small', {
        staticClass: "align-text-bottom"
      }, [_c('font-awesome-icon', {
        staticClass: "align-text-top",
        attrs: {
          "icon": "truck",
          "flip": "horizontal"
        }
      })], 1)]) : _vm._e(), dispatchRequest.isUnableToShipFinalable ? _c('b-button', {
        staticClass: "text-danger ml-1 m-0 p-0",
        attrs: {
          "size": "sm",
          "variant": "link",
          "title": "Dit product definitief op manco zetten"
        },
        on: {
          "click": function ($event) {
            return _vm.startQuickRerouteDispatchRequestLine(dispatchRequest, line, 'unable-to-ship-final');
          }
        }
      }, [_c('small', {
        staticClass: "align-text-bottom"
      }, [_c('font-awesome-icon', {
        staticClass: "align-text-top",
        attrs: {
          "icon": "truck",
          "flip": "horizontal"
        }
      })], 1)]) : _vm._e()], 1) : _vm._e()]), _c('b-td', {
        attrs: {
          "stacked-heading": "Artikel nr"
        }
      }, [_c('product-number', {
        attrs: {
          "number": line.product_identifier,
          "dispatch-request-line": line,
          "sales-order-line": _vm.getSalesOrderLine(line.sales_order_line_id)
        }
      }), _vm.hasPermission('orders.dispatchrequests.history') ? _c('b-button', {
        staticClass: "text-secondary ml-1 m-0 p-0",
        attrs: {
          "size": "sm",
          "variant": "link",
          "title": "Toon leveringsstatus-geschiedenis van dit product"
        },
        on: {
          "click": function ($event) {
            return _vm.showDrqLineHistory(line);
          }
        }
      }, [_c('small', {
        staticClass: "align-text-bottom"
      }, [_c('font-awesome-icon', {
        staticClass: "align-text-top",
        attrs: {
          "icon": "eye"
        }
      })], 1)]) : _vm._e(), _c('OmniDropdownIcon', {
        staticClass: "ml-2",
        attrs: {
          "cardItems": _vm.cardItems,
          "cardItemVariables": _vm.getArticleHoverCardVariables(line)
        }
      })], 1), _c('b-td', {
        attrs: {
          "stacked-heading": "Naam"
        }
      }, [_vm._v(_vm._s((_line$product_name2 = line.product_name) !== null && _line$product_name2 !== void 0 ? _line$product_name2 : _vm.getSalesOrderLine(line.sales_order_line_id).product_name))]), _vm.showFinancialAmounts && _vm.hasOriginalExtraOrderLineUnitPrice(line) ? _c('b-td', {
        attrs: {
          "stacked-heading": "Prijs totaal (ex. korting)"
        }
      }) : _vm.showFinancialAmounts ? _c('b-td', {
        attrs: {
          "stacked-heading": "Prijs totaal (ex. korting)"
        }
      }, [_vm._v(_vm._s(_vm._f("price")(_vm.getTotalPriceToShow(line, false))))]) : _vm._e(), _vm.showFinancialAmounts && _vm.hasOriginalExtraOrderLineUnitPrice(line) ? _c('b-td', {
        attrs: {
          "stacked-heading": "Korting"
        }
      }) : _vm.showFinancialAmounts ? _c('b-td', {
        attrs: {
          "stacked-heading": "Korting"
        }
      }, [_vm._v(_vm._s(_vm._f("price")(_vm.getDiscountPriceToShow(line))))]) : _vm._e(), _vm.showFinancialAmounts ? _c('b-td', {
        attrs: {
          "stacked-heading": "Prijs totaal"
        }
      }, [_vm._v(" " + _vm._s(_vm._f("price")(_vm.getTotalPriceToShow(line, true))) + " "), _vm.hasOriginalExtraOrderLineUnitPrice(line) ? _c('small', {
        staticClass: "mr-2"
      }, [_c('font-awesome-icon', {
        staticClass: "ml-2 text-info align-text-top",
        attrs: {
          "icon": "circle-info",
          "title": "Nalevering, de getoonde prijs is die van de originele regel"
        }
      })], 1) : _vm._e()]) : _vm._e(), _c('b-td', {
        attrs: {
          "stacked-heading": "Extra informatie"
        }
      }, [_vm.shouldShowProductInsufficientStock(dispatchRequest, line.product_identifier) ? _c('small', {
        staticClass: "text-danger"
      }, [_c('font-awesome-icon', {
        staticClass: "text-warning",
        attrs: {
          "icon": "triangle-exclamation"
        }
      }), _vm._v(" Onvoldoende voorraad"), _c('br')], 1) : _vm._e(), _vm.showDispatchRequestDeliveryFields(dispatchRequest) ? _c('small', [(_line$presales_active = line.presales_active) !== null && _line$presales_active !== void 0 && _line$presales_active.length ? _c('span', [_vm._v("Presale"), _c('br')]) : _vm.salesOrder.promised_delivery_date ? _c('span', [_vm._v("Beloofde leverdatum: " + _vm._s(_vm._f("date")(_vm.salesOrder.promised_delivery_date))), _c('br')]) : _vm._e()]) : _vm._e(), (_vm$getSalesOrderLine = _vm.getSalesOrderLine(line.sales_order_line_id)) !== null && _vm$getSalesOrderLine !== void 0 && (_vm$getSalesOrderLine2 = _vm$getSalesOrderLine.metadata) !== null && _vm$getSalesOrderLine2 !== void 0 && _vm$getSalesOrderLine2.private_copy_levy ? _c('small', [_vm._v(" Thuiskopieheffing: " + _vm._s(_vm._f("price")(((_vm$getSalesOrderLine3 = _vm.getSalesOrderLine(line.sales_order_line_id)) === null || _vm$getSalesOrderLine3 === void 0 ? void 0 : (_vm$getSalesOrderLine4 = _vm$getSalesOrderLine3.metadata) === null || _vm$getSalesOrderLine4 === void 0 ? void 0 : _vm$getSalesOrderLine4.private_copy_levy) * line.quantity))), _c('br')]) : _vm._e(), dispatchRequest.storage_location_id && dispatchRequest.status === 'requested' ? _c('small', [_c('i', [_vm._v("Gescand: " + _vm._s(line.final_scanned_quantity))])]) : _vm._e(), (_vm$getSalesOrderLine5 = _vm.getSalesOrderLine(line.sales_order_line_id)) !== null && _vm$getSalesOrderLine5 !== void 0 && (_vm$getSalesOrderLine6 = _vm$getSalesOrderLine5.promotions) !== null && _vm$getSalesOrderLine6 !== void 0 && _vm$getSalesOrderLine6.length ? _c('p', {
        staticClass: "m-0"
      }, [_c('small', {
        staticClass: "text-primary",
        staticStyle: {
          "text-decoration": "underline dotted",
          "cursor": "default"
        },
        attrs: {
          "id": `promotions_${line.id}`
        }
      }, [_vm._v(" " + _vm._s(_vm.getSalesOrderLine(line.sales_order_line_id).promotions.length) + " promotie"), _vm.getSalesOrderLine(line.sales_order_line_id).promotions.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e()]), _c('b-popover', {
        attrs: {
          "target": `promotions_${line.id}`,
          "triggers": "hover",
          "placement": "auto",
          "no-fade": "",
          "delay": "0",
          "custom-class": "promotion-popover"
        }
      }, [_c('promotion-lines', {
        staticStyle: {
          "background": "white"
        },
        attrs: {
          "promotion-lines": _vm.getSalesOrderLine(line.sales_order_line_id).promotions,
          "sales-order-line": _vm.getSalesOrderLine(line.sales_order_line_id),
          "dispatch-request-line": line
        }
      })], 1)], 1) : _vm._e(), dispatchRequest.status.startsWith('return-') ? _c('small', [_c('strong', {
        staticClass: "drq-info-heading"
      }, [_vm._v("Retourreden:")]), _vm._v(" " + _vm._s((_vm$getReturnReason$d = _vm.getReturnReason(line.return_reason_id).display_name) !== null && _vm$getReturnReason$d !== void 0 ? _vm$getReturnReason$d : 'onbekend')), _c('br')]) : _vm._e(), dispatchRequest.status === 'return-received' ? _c('small', [_c('strong', {
        staticClass: "drq-info-heading"
      }, [_vm._v("Staat:")]), _vm._v(" " + _vm._s((_vm$getProductState$d = _vm.getProductState(line.product_state_id).display_name) !== null && _vm$getProductState$d !== void 0 ? _vm$getProductState$d : 'onbekend')), _c('br')]) : _vm._e(), line.goods_receipt_line_id ? _c('small', [_vm._v(" In goederenontvangst: "), _vm.hasLocationId((_line$goods_receipt_l = line.goods_receipt_line) === null || _line$goods_receipt_l === void 0 ? void 0 : _line$goods_receipt_l.goods_receipt.recipient_location_id) ? _c('b-link', {
        attrs: {
          "to": _vm.getGoodsReceiptViewLink(line.goods_receipt_line.goods_receipt)
        }
      }, [_vm._v(_vm._s((_line$goods_receipt_l2 = line.goods_receipt_line.goods_receipt) === null || _line$goods_receipt_l2 === void 0 ? void 0 : _line$goods_receipt_l2.identifier))]) : _c('span', [_vm._v(_vm._s((_line$goods_receipt_l3 = line.goods_receipt_line.goods_receipt) === null || _line$goods_receipt_l3 === void 0 ? void 0 : _line$goods_receipt_l3.identifier))]), _c('br')], 1) : _vm._e()])], 1);
    }), 1)], 1)], 1), (_dispatchRequest$trac = dispatchRequest.tracking_codes) !== null && _dispatchRequest$trac !== void 0 && _dispatchRequest$trac.length || !_vm.rerouteMode && dispatchRequest.dispatch_request_batch_id && _vm.hasPermission('orders.batch.process.sort') || dispatchRequest.storage_location_id ? _c('b-card-footer', {
      attrs: {
        "footer-bg-variant": "light",
        "footer-border-variant": "light"
      }
    }, [_c('b-row', {
      staticClass: "w-100"
    }, [_c('b-col', {
      staticClass: "pr-4 text-black-50 mb-4 mb-md-0",
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [dispatchRequest.tracking_codes.length ? _c('span', [_vm._v(" Track & trace: "), _vm._l(dispatchRequest.tracking_codes, function (trackingCode, index) {
      return _c('a', {
        staticClass: "text-info d-inline-block mx-1",
        attrs: {
          "href": trackingCode.url,
          "target": "_blank"
        }
      }, [_vm._v("[" + _vm._s(_vm.datetime(trackingCode.updated_at)) + "]")]);
    })], 2) : _vm._e()]), !_vm.rerouteMode ? _c('b-col', {
      staticClass: "text-black-50",
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [dispatchRequest.dispatch_request_batch_id && _vm.hasPermission('orders.batch.process.sort') ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v("In batch: ")]), _c('b-link', {
      attrs: {
        "to": {
          name: 'ShipmentBatchView',
          params: {
            locationTypeIdentifier: dispatchRequest.dispatcher_type,
            locationIdentifier: dispatchRequest.dispatcher_identifier,
            batchIdentifier: dispatchRequest.dispatch_request_batch.identifier
          }
        }
      }
    }, [_vm._v(" " + _vm._s(dispatchRequest.dispatch_request_batch.identifier) + " ")]), _c('br')], 1) : _vm._e(), dispatchRequest.storage_location_id ? _c('span', [_c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v("In sorteerzone:")]), _vm._v(" " + _vm._s((_dispatchRequest$stor = dispatchRequest.storage_location) === null || _dispatchRequest$stor === void 0 ? void 0 : _dispatchRequest$stor.storage_zone.display_name) + " → " + _vm._s((_dispatchRequest$stor2 = dispatchRequest.storage_location) === null || _dispatchRequest$stor2 === void 0 ? void 0 : _dispatchRequest$stor2.display_name) + " ")]) : _vm._e(), _c('br')]) : _vm._e()], 1)], 1) : _vm._e()], 1) : _vm._e();
  }), _c('b-alert', {
    attrs: {
      "show": _vm.rerouteMode && !_vm.hasReroutableDispatchRequests,
      "variant": "light"
    }
  }, [_vm._v(" Er zijn geen leveringen met een status die toegestaan is om te rerouten. ")]), _vm.rerouteMode && _vm.hasReroutableDispatchRequests ? _c('h5', {
    staticClass: "mb-2 text-dark"
  }, [_vm._v("Nieuwe leveringen")]) : _vm._e(), _vm.rerouteMode && _vm.hasReroutableDispatchRequests ? _c('div', [_c('b-alert', {
    staticClass: "px-0 pt-1 pb-4",
    attrs: {
      "show": !_vm.newDispatchRequests.length,
      "variant": "light"
    }
  }, [_vm.isLoadingAllLocations ? _c('span', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }), _vm._v(" Bezig met laden dispatch opties ")], 1) : _c('span', [_vm._v("Voeg een lege levering toe, of maak een levering aan met de waardes van een bestaande levering.")])]), _vm._l(_vm.newDispatchRequests, function (dispatchRequest, index) {
    return _c('b-collapse', {
      key: index,
      attrs: {
        "visible": true,
        "appear": true
      }
    }, [_c('b-card', {
      staticClass: "dispatchRequest mb-4 font-size-md",
      class: {
        'opacity-05': !_vm.rerouteMode
      },
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      attrs: {
        "header-bg-variant": "light"
      }
    }, [_c('b-col', {
      staticClass: "p-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('h6', {
      staticClass: "mb-0"
    }, [_c('span', {
      attrs: {
        "title": dispatchRequest.status
      }
    }, [_c('dispatch-request-icon', {
      staticClass: "mr-2",
      attrs: {
        "status": dispatchRequest.status
      }
    })], 1), _c('strong', {
      staticClass: "drq-info-heading"
    }, [_vm._v(_vm._s(_vm._f("uppercase")(_vm._f("dispatchRequestStatus")(dispatchRequest.status))))])])]), _c('b-col', {
      staticClass: "text-black-50",
      attrs: {
        "cols": "3"
      }
    }, [_c('b-row', [_c('b-col', {
      staticClass: "px-0 py-1 text-right",
      attrs: {
        "cols": "5"
      }
    }, [_vm._v(" Uitleverdatum: ")]), _c('b-col', {
      staticClass: "px-1",
      attrs: {
        "cols": "7"
      }
    }, [_c('b-input', {
      class: {
        'input-not-valid': dispatchRequest.dispatch_date < _vm.today
      },
      attrs: {
        "type": "date",
        "size": "sm",
        "min": _vm.today
      },
      model: {
        value: dispatchRequest.dispatch_date,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatch_date", $$v);
        },
        expression: "dispatchRequest.dispatch_date"
      }
    })], 1)], 1)], 1), _c('b-col', {
      staticClass: "text-black-50 pl-5",
      attrs: {
        "cols": "6"
      }
    }, [_c('b-row', [_c('b-col', {
      staticClass: "p-0 pl-1",
      attrs: {
        "cols": "3"
      }
    }, [_c('b-select', {
      class: {
        'input-not-valid': !dispatchRequest.dispatcher_type
      },
      attrs: {
        "size": "sm",
        "required": "",
        "readonly": ""
      },
      model: {
        value: dispatchRequest.dispatcher_type,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatcher_type", $$v);
        },
        expression: "dispatchRequest.dispatcher_type"
      }
    }, [_c('b-select-option', {
      staticClass: "text-secondary",
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Locatietype")]), _vm._l(_vm.$store.state.locationDataTypes.locationTypes, function (dispatcherType) {
      return _c('b-select-option', {
        key: dispatcherType.identifier,
        attrs: {
          "value": dispatcherType.identifier
        }
      }, [_vm._v(" " + _vm._s(dispatcherType.display_name) + " ")]);
    })], 2)], 1), _c('b-col', {
      staticClass: "p-0 pl-1",
      attrs: {
        "cols": "5"
      }
    }, [_c('b-select', {
      class: {
        'input-not-valid': !dispatchRequest.dispatcher_identifier && dispatchRequest.dispatcher_type
      },
      attrs: {
        "size": "sm",
        "disabled": !dispatchRequest.dispatcher_type
      },
      on: {
        "change": function ($event) {
          return _vm.dispatcherChanged(dispatchRequest);
        }
      },
      model: {
        value: dispatchRequest.dispatcher_identifier,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatcher_identifier", $$v);
        },
        expression: "dispatchRequest.dispatcher_identifier"
      }
    }, [_c('b-select-option', {
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Locatie")]), _vm._l(_vm.dispatchersForSelectedDispatcherType(dispatchRequest, _vm.salesOrder.sales_channel_identifier), function (dispatcher) {
      return _c('b-select-option', {
        key: dispatcher.identifier,
        attrs: {
          "value": dispatcher.identifier
        }
      }, [_vm._v(_vm._s(dispatcher.display_name) + " ")]);
    })], 2)], 1), _c('b-col', {
      staticClass: "p-0 pl-1",
      attrs: {
        "cols": "4"
      }
    }, [_c('b-overlay', {
      attrs: {
        "show": _vm.isLoadingDispatcherTypes,
        "spinner-small": ""
      }
    }, [_c('b-select', {
      key: dispatchRequest.dispatcher_identifier,
      class: {
        'input-not-valid': dispatchRequest.dispatcher_identifier && !dispatchRequest.dispatch_type_identifier
      },
      attrs: {
        "size": "sm",
        "disabled": !dispatchRequest.dispatcher_identifier && !_vm.dispatcherInfo.length
      },
      on: {
        "change": function ($event) {
          return _vm.dispatchTypeChanged(dispatchRequest);
        }
      },
      model: {
        value: dispatchRequest.dispatch_type_identifier,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatch_type_identifier", $$v);
        },
        expression: "dispatchRequest.dispatch_type_identifier"
      }
    }, [_c('b-select-option', {
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Dispatchtype")]), _vm._l(_vm.dispatchTypesForSelectedDispatcher(dispatchRequest), function (type) {
      return _c('b-select-option', {
        key: type.identifier,
        attrs: {
          "value": type.identifier
        }
      }, [_vm._v(_vm._s(type.display_name))]);
    })], 2)], 1)], 1)], 1)], 1), _c('b-col', {
      staticClass: "text-right pr-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('b-modal', {
      key: `suggestion-for-manual-dispatch-request-modal`,
      attrs: {
        "id": `suggestion-for-manual-dispatch-request-modal`,
        "size": "md",
        "centered": "",
        "dialog-class": "shadow-none",
        "title": "Locatie suggestie vragen"
      },
      on: {
        "ok": function ($event) {
          return _vm.getSuggestionForDispatchRequest(dispatchRequest, true);
        }
      },
      model: {
        value: dispatchRequest.isSuggestionModalOpen,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "isSuggestionModalOpen", $$v);
        },
        expression: "dispatchRequest.isSuggestionModalOpen"
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "10"
      }
    }, [_vm._v(" Wat is het maximaal aantal leveringen? ")]), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-input', {
      attrs: {
        "type": "number",
        "size": "sm",
        "min": 1
      },
      model: {
        value: _vm.rerouteMaxDispatchRequests,
        callback: function ($$v) {
          _vm.rerouteMaxDispatchRequests = $$v;
        },
        expression: "rerouteMaxDispatchRequests"
      }
    })], 1)], 1), _c('b-row', {
      staticClass: "mt-4"
    }, [_c('b-col', {
      attrs: {
        "cols": "10 pt-1"
      }
    }, [_vm._v(" Sluit eerder gebruikte locaties uit: ")]), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('b-checkbox', {
      attrs: {
        "type": "number",
        "size": "lg",
        "switch": ""
      },
      model: {
        value: _vm.rerouteSuggestionExcludePreviousLocations,
        callback: function ($$v) {
          _vm.rerouteSuggestionExcludePreviousLocations = $$v;
        },
        expression: "rerouteSuggestionExcludePreviousLocations"
      }
    })], 1)], 1)], 1), _vm.hasPermission('orders.dispatchrequests.suggestionbased.reroute') && _vm.rerouteMode ? _c('b-button', {
      attrs: {
        "variant": "outline-secondary",
        "size": "sm",
        "title": "Een locatie suggestie vragen",
        "disabled": dispatchRequest.dispatch_request_lines.length === 0
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSuggestionForDispatchRequestModal(dispatchRequest);
        }
      }
    }, [_c('small', {
      staticClass: "text-dark"
    }, [!_vm.isRequestingSuggestion ? _c('font-awesome-icon', {
      staticClass: "align-text-top",
      attrs: {
        "icon": "user-graduate"
      }
    }) : _vm._e(), _vm.isRequestingSuggestion ? _c('font-awesome-icon', {
      staticClass: "align-text-top",
      attrs: {
        "icon": "spinner",
        "spin": _vm.isRequestingSuggestion
      }
    }) : _vm._e()], 1)]) : _vm._e(), _c('b-button', {
      staticClass: "m-1",
      attrs: {
        "variant": "outline-danger",
        "size": "sm",
        "disabled": !_vm.canNewDispatchRequestBeRemoved(index),
        "title": _vm.canNewDispatchRequestBeRemoved(index) ? 'Verwijderen' : 'Kan niet verwijderen'
      },
      on: {
        "click": function ($event) {
          return _vm.removeNewDispatchRequest(index);
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "trash"
      }
    })], 1)], 1)], 1), _c('b-card-body', [_c('b-table-simple', {
      staticClass: "ml-2 my-4 b",
      attrs: {
        "small": "",
        "borderless": ""
      }
    }, [_c('colgroup', [_c('col', {
      staticStyle: {
        "width": "2rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "7rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "10rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "auto"
      }
    }), _c('col', {
      staticStyle: {
        "width": "7rem"
      }
    }), _c('col', {
      staticStyle: {
        "width": "14rem"
      }
    })]), _c('b-thead', [_c('b-tr', [_c('b-th'), _c('b-th', [_vm._v("Aantal")]), _c('b-th', [_vm._v("Artikel nr")]), _c('b-th', [_vm._v("Naam")]), _c('b-th', [_vm._v("Prijs totaal")]), _c('b-th', [_vm._v("Extra informatie")])], 1)], 1), _c('draggable', {
      attrs: {
        "tag": "tbody",
        "group": "productsInDispatchRequest",
        "forceFallback": true /* Required for cursor change to work */,
        "move": _vm.productMoving,
        "data-dispatch-request-id": dispatchRequest.id,
        "data-is-existing-dispatch-request": "0"
      },
      on: {
        "end": _vm.productMoved,
        "start": function ($event) {
          _vm.isDragging = true;
        },
        "unchoose": function ($event) {
          _vm.isDragging = false;
        }
      },
      model: {
        value: dispatchRequest.dispatch_request_lines,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "dispatch_request_lines", $$v);
        },
        expression: "dispatchRequest.dispatch_request_lines"
      }
    }, _vm._l(dispatchRequest.dispatch_request_lines, function (line, index) {
      var _line$product_name3;
      return _c('b-tr', {
        key: `${line.id}_${index}`,
        staticClass: "draggable",
        attrs: {
          "title": line.gui.isInvalidlyPlacedReason
        }
      }, [_c('b-td', {
        staticClass: "text-secondary draggable",
        staticStyle: {
          "cursor": "grab"
        }
      }, [_c('font-awesome-icon', {
        staticClass: "text-info",
        attrs: {
          "icon": "grip-vertical"
        }
      })], 1), _c('b-td', [_vm._v(" " + _vm._s(line.quantity) + " "), line.quantity > 1 ? _c('b-button', {
        staticClass: "p-0",
        class: {
          'text-primary': 1
        },
        attrs: {
          "title": "Splitsen",
          "variant": "link",
          "size": "sm"
        },
        on: {
          "click": function ($event) {
            return _vm.startSplitLine(dispatchRequest, line);
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "share-alt"
        }
      })], 1) : _vm._e()], 1), _c('b-td', [_c('product-number', {
        attrs: {
          "number": line.product_identifier,
          "dispatch-request-line": line,
          "sales-order-line": _vm.getSalesOrderLine(line.sales_order_line_id)
        }
      }), line.gui.isInvalidlyPlaced ? _c('font-awesome-icon', {
        staticClass: "text-danger cursor-default",
        attrs: {
          "icon": "exclamation-triangle"
        }
      }) : _vm._e()], 1), _c('b-td', [_vm._v(_vm._s((_line$product_name3 = line.product_name) !== null && _line$product_name3 !== void 0 ? _line$product_name3 : _vm.getSalesOrderLine(line.sales_order_line_id).product_name))]), _c('b-td', [_vm._v(" " + _vm._s(_vm._f("price")(_vm.getTotalPriceToShow(line, true))) + " "), _vm.hasOriginalExtraOrderLineUnitPrice(line) ? _c('small', {
        staticClass: "mr-2"
      }, [_c('font-awesome-icon', {
        staticClass: "ml-2 text-info align-text-top",
        attrs: {
          "icon": "circle-info",
          "title": "Nalevering, de getoonde prijs is die van de originele regel"
        }
      })], 1) : _vm._e()]), _c('b-td')], 1);
    }), 1), _c('b-tr', [_c('td'), _c('td', {
      staticClass: "pt-2",
      attrs: {
        "colspan": "5"
      }
    }, [_c('span', {
      staticClass: "text-secondary font-italic"
    }, [_vm._v(" Sleep orderregels hier naartoe ")])])]), _c('b-tr', [_c('b-td'), _c('b-td', {
      staticClass: "pt-3"
    }, [_c('strong', [_vm._v("Totaal aantal")])]), _c('b-td'), _c('b-td'), _c('b-td', {
      staticClass: "pt-3",
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v("Totaal prijs levering")])])], 1), _c('b-tr', [_c('b-td', {
      staticClass: "text-secondary draggable",
      staticStyle: {
        "cursor": "grab"
      }
    }), _c('b-td', [_vm._v(" " + _vm._s(_vm.getTotalQuantityForDrq(dispatchRequest.dispatch_request_lines)) + " ")]), _c('b-td'), _c('b-td'), _c('b-td', [_vm._v(" " + _vm._s(_vm._f("price")(_vm.getTotalPriceToShowForDrq(dispatchRequest.dispatch_request_lines))) + " ")]), _c('b-td')], 1)], 1)], 1), _c('b-card-footer', {
      attrs: {
        "footer-bg-variant": "light",
        "footer-border-variant": "light"
      }
    }, [_c('b-col', {
      staticClass: "px-0",
      attrs: {
        "cols": "2"
      }
    }, [_c('b-overlay', {
      attrs: {
        "show": _vm.isLoadingDispatcherTypes,
        "spinner-small": ""
      }
    }, [_c('b-select', {
      key: dispatchRequest.dispatcher_identifier,
      class: {
        'input-not-valid': dispatchRequest.dispatch_type_identifier && !dispatchRequest.carrier_identifier
      },
      attrs: {
        "size": "sm",
        "disabled": !dispatchRequest.dispatch_type_identifier
      },
      on: {
        "change": function ($event) {
          return _vm.carrierChanged(dispatchRequest);
        }
      },
      model: {
        value: dispatchRequest.carrier_identifier,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "carrier_identifier", $$v);
        },
        expression: "dispatchRequest.carrier_identifier"
      }
    }, [_c('b-select-option', {
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Vervoerder")]), _vm._l(_vm.carriersForSelectedDispatcherAndDispatchType(dispatchRequest), function (carrier) {
      return _c('b-select-option', {
        key: carrier.identifier,
        attrs: {
          "value": carrier.identifier
        }
      }, [_vm._v(" " + _vm._s(carrier.display_name) + " ")]);
    })], 2)], 1)], 1), _c('b-col', {
      staticClass: "pl-1",
      attrs: {
        "cols": "2"
      }
    }, [_c('b-overlay', {
      attrs: {
        "show": _vm.isLoadingDispatcherTypes,
        "spinner-small": ""
      }
    }, [_c('b-select', {
      key: dispatchRequest.dispatcher_identifier,
      class: {
        'input-not-valid': !dispatchRequest.carrier_method_identifier && dispatchRequest.dispatch_type_identifier
      },
      attrs: {
        "size": "sm",
        "disabled": !dispatchRequest.carrier_identifier
      },
      model: {
        value: dispatchRequest.carrier_method_identifier,
        callback: function ($$v) {
          _vm.$set(dispatchRequest, "carrier_method_identifier", $$v);
        },
        expression: "dispatchRequest.carrier_method_identifier"
      }
    }, [_c('b-select-option', {
      attrs: {
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("Vervoersmethode")]), _vm._l(_vm.carrierMethodsForSelectedCarrierAndDispatcherAndDispatchType(dispatchRequest), function (carrierMethod) {
      return _c('b-select-option', {
        key: carrierMethod.identifier,
        attrs: {
          "value": carrierMethod.identifier
        }
      }, [_vm._v(" " + _vm._s(carrierMethod.display_name) + " ")]);
    })], 2)], 1)], 1)], 1)], 1)], 1);
  }), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.unsplitAllLines
    }
  }, [_vm._v("Optimaliseren")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoadingAllLocations
    },
    on: {
      "click": function ($event) {
        return _vm.addDispatchRequest(_vm.newDispatchRequest);
      }
    }
  }, [_vm._v(" + Nieuwe toewijzing "), _vm.isLoadingAllLocations ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e()], 1), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "success",
      "size": "sm",
      "disabled": !_vm.canReroutingBeSaved
    },
    on: {
      "click": _vm.save
    }
  }, [_vm.isSaving ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('span', [_vm._v("Opslaan")])], 1)], 1)], 2) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "cascaded-drqs-modal",
      "title": `Gelinkte leveringen`,
      "size": "xl",
      "centered": "",
      "dialog-class": "shadow-none",
      "hide-footer": ""
    }
  }, [_c('dispatch-requests', {
    attrs: {
      "sales-order": _vm.salesOrder,
      "dispatch-requests": _vm.showCascadedDispatchRequests,
      "hide-actions": true
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "return-drq-items-modal",
      "title": `Artikelen retourneren`,
      "size": "xl",
      "centered": "",
      "dialog-class": "shadow-none",
      "hide-footer": ""
    }
  }, [_c('ReturnDrqItems', {
    attrs: {
      "dispatch-request": _vm.returnDrq,
      "sales-order": _vm.salesOrder
    },
    on: {
      "close": function ($event) {
        return _vm.$bvModal.hide('return-drq-items-modal');
      },
      "dataChanged": function ($event) {
        return _vm.$emit('dataChanged');
      }
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }